module.exports = __webpack_public_path__ + "img/guardian_01.673fecb6.png";